(function ($) {
  $('a[target="_blank"]:not([aria-label])').attr(
    "aria-label",
    "This link opens in a new tab"
  );

  $(".homepage__seo-section ul").attr("role", "list");
})(jQuery);
